'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Moment'];
module.exports = angular.module('AVRO.Common.LiteDataService', dependencies).factory('LiteDataService', require('./services/LiteDataService'));